export const ANALYTICS_LOCAL_STORAGE_ACCOUNT_ID_KEY = "analytics:accountId";
export const ANALYTICS_LOCAL_STORAGE_TRANSCRIPT_ID_KEY =
  "analytics:chatTranscriptId";
